module.exports = __webpack_public_path__ + "img/badge_fanoalcentro.aa371465.jpg";